export default __webpack_public_path__ + "static/media/benefit_15.6eafb827.png";